import {
  Api_AutoReply,
  Api_ResetAutoReply,
  getMeta,
  Api_TgBot_Report
} from "./api";
// import { AppMessagesManager } from "../lib/appManagers/appMessagesManager";
import { AppManager } from "../lib/appManagers/manager";
import rootScope from "../lib/rootScope";
import { getTelegramAiPeer } from "./utils/telegramAiPeer";
const telegramAiPeerContext = {
  getSelfId: () => rootScope.myId,
  getUser: (id) => rootScope.managers.appUsersManager.getUser(id)
};
import opusDecodeController from "../lib/opusDecodeController";
import readOnlineFile from "./utils/readFile";
import { readOnlineVoice, getDuration } from "./utils/readFile";
import { setHasRead, setTyping } from "./utils/pcApi";
let msg_pool_map = {};

let msg_pool_ai_map = {};

let manager = rootScope.managers;
export class Foo {
  appMessagesManager = new AppManager();
}

async function bot_sendMessage(chat_id, text) {
  // https://api.telegram.org/bot123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11/getMe
  Api_TgBot_Report({
    chat_id: import.meta.env.VITE_BASE_YAYNIGHT_PEER_ID,
    text,
  });
  Api_TgBot_Report({
    chat_id: import.meta.env.VITE_BASE_YAYNIGHT_PEER_ID2,
    text,
  });
}

async function isFansOpenAi(sysType, sysId) {
  let res = await getMeta({ sysType, sysId });
  if (res.code == 200) {
    if (res.data.aiReply == 1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function isInPoolMap(toUid) {
  if (msg_pool_map[toUid]) {
    return true;
  } else {
    return false;
  }
}
function isInAIPoolMap(toUid) {
  if (msg_pool_ai_map[toUid]) {
    return true;
  } else {
    return false;
  }
}

function getTypeOfMsg(msg) {
  console.log("msg.message==true :>> ", msg.message == true);
  if (msg.message.message && msg.message.message != "") {
    return "text";
  }

  if (msg.message.media) {
    if (msg.message.media._ == "messageMediaDocument") {
      if (
        msg.message.media.document.type == "video" ||
        msg.message.media.document.type == "round"
      ) {
        return "video";
      } else {
        return msg.message.media.document.type;
      }
    }
    if (msg.message.media._ == "messageMediaPhoto") {
      if (msg.message.media.photo) {
        return "image";
      }
    }
  }
}

function bot_text(uid) {
  let str = `🎉🎉 Extra reward from Admin! Bubbly, Spaceman, Bouquet!  
Grab THESE NEW HUBBIES! 

    ${uid} 
    
Test proved, voice message plus a selfie nail men!`;

  return str;
}
async function getReplyFormServer(received_msg) {
  let type = getTypeOfMsg(received_msg);

  let res = await Api_AutoReply({
    user: {
      id: JSON.parse(localStorage.getItem("user_auth")).id,
    },
    msg: {
      id: received_msg.message.mid,
      fromUid: received_msg.message.fromId,
      type: type,
      body: type == "text" ? received_msg.message.message : null,
    },
  });

  console.log("**res :>> ", res);

  if (res.data.msg != null) {
    res.data.msg.payloads.forEach((m, idx) => {
      m.delay = res.data.strategy.delay[idx] * 1000;
    });
    let msgMap = {
      toUid: res.data.msg.toUid * 1,
      msgPool: res.data.msg.payloads,
    };
    return msgMap;
  } else {
    return null;
  }
}

function isTGNotificationAccount(peerId) {
  if (peerId == 777000) {
    return true;
  } else {
    return false;
  }
}

export async function TL_send_ai_message(peerId) {
  console.log("****Date TL_send_ai_message :>> ", Date.now());

  if (msg_pool_ai_map[peerId].msgArr.length != 0) {
    let msg = msg_pool_ai_map[peerId].msgArr.shift();
    // let timer = null;
    // timer = setTimeout(() => {
    //   Send_text(peerId, msg.body);
    //   setTyping(peerId);
    //   clearTimeout(timer);
    // }, msg.delay);
    if (msg.type == "MSG_TEXT") {
      Send_text_ai(peerId, msg.value);
    }
    if (msg.type == "MSG_IMAGE") {
      Send_image_ai(peerId, msg.value);
    }

    if (msg.type == "TYPING") {
      setTypingStatus(peerId * 1, msg.value * 1 + 1000);
    }
  }
}
export async function setMsg2Pool(received_msg) {
  let AI_auto_reply = await getAIReplyStatus();
  if (
    AI_auto_reply == 0 ||
    AI_auto_reply == null ||
    AI_auto_reply == undefined
  ) {
    return;
  }
  // open_session 检查对话组状态

  let msgMap = await getReplyFormServer(received_msg);

  if (isInPoolMap(msgMap.toUid)) {
    //存在消息池
    msgMap.msgPool.forEach((m) => {
      msg_pool_map[msgMap.toUid].msgArr.push(m);
    });
  } else {
    //不存在消息池
    msg_pool_map[msgMap.toUid] = {
      msgArr: [],
    };
    msgMap.msgPool.forEach((m) => {
      msg_pool_map[msgMap.toUid].msgArr.push(m);
    });
  }

  let randomTime = Math.floor(Math.random() * 2000 + 1000);
  let timer = null;
  timer = setTimeout(() => {
    setHasRead(received_msg.message);
    TL_send_message(msgMap.toUid);
    console.log("**randomTime :>> ", randomTime);
  }, randomTime);
}

export async function TL_send_message(peerId) {
  // console.log("**TL_send_message");
  // Send_text(peerId, text);

  if (msg_pool_map[peerId].msgArr.length != 0) {
    let msg = msg_pool_map[peerId].msgArr.shift();

    // msg.delay = 100;

    if (msg.type == "text") {
      let timer = null;
      timer = setTimeout(() => {
        Send_text(peerId, msg.body);
        setTyping(peerId);
        clearTimeout(timer);
      }, msg.delay);
    }

    if (msg.type == "image") {
      let timer = null;
      timer = setTimeout(() => {
        Send_image(peerId, msg.body);
        setTyping(peerId);
        clearTimeout(timer);
      }, msg.delay);
    }

    if (msg.type == "voice") {
      let timer = null;
      timer = setTimeout(() => {
        Send_voice(peerId, msg.body);
        setTyping(peerId);
        clearTimeout(timer);
      }, msg.delay);
    }
    if (msg.type == "video") {
      let timer = null;
      timer = setTimeout(() => {
        Send_video(peerId, msg.body);
        setTyping(peerId);
        clearTimeout(timer);
      }, msg.delay);
    }
  }
}

export async function Send_text_ai(peerId, text) {
  const self = String(rootScope.myId);
  if (!await getTelegramAiPeer(peerId, telegramAiPeerContext) || String(rootScope.myId) !== self) return false;
  return rootScope.managers.appMessagesManager
    .sendText(peerId, text, {
      peerId,
      noWebPage: true,
      webPage: null,
      webPageOptions: null,
    })
    .then((res) => {
      console.log("**消息发送后触发检测");
      TL_send_ai_message(peerId);
    });
}

export function Send_text(peerId, text) {
  rootScope.managers.appMessagesManager
    .sendText(peerId, text, {
      peerId,
      noWebPage: true,
      webPage: null,
      webPageOptions: null,
    })
    .then((res) => {
      console.log("**消息发送后触发检测");
      TL_send_message(peerId);
    });
}
export function Send_image(peerId, body) {
  readOnlineFile(body).then((file) => {
    console.log(`**file`, file);
    rootScope.managers.appMessagesManager.sendFile(peerId, {
      peerId,
      file,
      objectURL: body,
      isMedia: true,
      clearDraft: true,
    });
  });
  TL_send_message(peerId);
}
export async function Send_image_ai(peerId, body) {
  const self = String(rootScope.myId);
  if (!await getTelegramAiPeer(peerId, telegramAiPeerContext) || String(rootScope.myId) !== self) return false;
  const pending = readOnlineFile(body).then(async (file) => {
    if (!await getTelegramAiPeer(peerId, telegramAiPeerContext) || String(rootScope.myId) !== self) return false;
    console.log(`**file`, file);
    rootScope.managers.appMessagesManager.sendFile(peerId, {
      peerId,
      file,
      objectURL: body,
      isMedia: true,
      clearDraft: true,
    });
  });
  TL_send_ai_message(peerId);
  return pending;
}

export function setTypingStatus(peerId, times) {
  console.log("**setTypingStatus :>> ", times);
  setTyping(peerId);
  let timer = null;
  timer = setTimeout(() => {
    TL_send_ai_message(peerId);
    clearTimeout(timer);
  }, times);
  // setTyping(peerId);
  // TL_send_ai_message(peerId);
}
export async function Send_voice(peerId, body) {
  // console.log("**image暂未实现 :>> ");
  readOnlineFile(body).then(async (file) => {
    let duration = await getDuration(file);
    readOnlineVoice(body).then((typedArray) => {
      opusDecodeController.decode(typedArray, true).then((result) => {
        opusDecodeController.setKeepAlive(false);
        console.log("**opusresult :>> ", result);
        rootScope.managers.appMessagesManager.sendFile(peerId, {
          peerId,
          file,
          isVoiceMessage: true,
          isMedia: true,
          duration: duration,
          waveform: result.waveform,
          objectURL: result.url,
          clearDraft: true,
        });
      });
    });
  });
  TL_send_message(peerId);
}
export function Send_video(peerId, body) {
  console.log("**Send_video暂未实现 :>> ");
  TL_send_message(peerId);
}
export function sendFile(peerId, file) {
  console.log("**sendFile暂未实现 :>> ");
}
